export const batchList = [
    // {
    //     id: 1,
    //     name: 'Tutti'
    // },
    {
        id: 2,
        name: 'ARTIFICIAL INTELLIGENCE/CYBERSECURITY',
        displayName: 'AI/CYBERSECURITY',
        selected: true,
        icon: 'heroicons_outline:desktop-computer'
    },
    {
        id: 3,
        name: 'AEROSPACE',
        displayName: 'AEROSPACE',
        icon: 'mat_outline:airplane_ticket',
        selected: true
    },
    {
        id: 7,
        name: 'QUANTUM TECHNOLOGIES',
        displayName: 'QUANTUM TECHNOLOGIES',
        icon: 'heroicons_outline:cube-transparent',
        selected: true
    },

    {
        id: 4,
        name: 'CLIMATE TECH',
        displayName: 'CLIMATE TECH',
        icon: 'heroicons_outline:sun',
        selected: true
    },
    {
        id: 6,
        name: 'MEDTECH/LIFE SCIENCE',
        displayName: 'MEDTECH/LIFE SCIENCE',
        icon: 'mat_outline:medical_services',
        selected: true
    },

    {
        id: 5,
        name: 'ADVANCED MANUFACTURING',
        displayName: 'ADV. MANUFACTURING',
        icon: 'mat_outline:settings_input_component',
        selected: true
    },
];

export const inversoBatchList = [
    // {
    //     id: 1,
    //     name: 'Tutti'
    // },
    {
        id: 2,
        name: 'AI',
        displayName: 'Intelligenza Artificiale',
        selected: true,
        icon: 'heroicons_outline:desktop-computer'
    },
    {
        id: 3,
        name: 'Manifattura Avanzata',
        displayName: 'Manifattura Avanzata',
        icon: 'mat_outline:airplane_ticket',
        selected: true
    },
    {
        id: 7,
        name: 'Materiali Avanzati',
        displayName: 'Materiali Avanzati',
        icon: 'heroicons_outline:cube-transparent',
        selected: true
    }
];

export const sseBatchList = [
    {
        id: 1,
        name: 'Smart Materials',
        displayName: 'Smart Materials',
        selected: true,
        color: 'rgb(231,91,91)', // Red
        backgroundClass: 'bg-red-100', // Background
        textClass: 'text-red-800', // Text
    },
    {
        id: 2,
        name: 'Generative AI',
        displayName: 'Generative AI',
        selected: true,
        color: 'rgb(63,147,249)', // Blue
        backgroundClass: 'bg-blue-100', // Background
        textClass: 'text-blue-800', // Text
    },
    {
        id: 3,
        name: 'Advanced Manufacturing',
        displayName: 'Advanced Manufacturing',
        selected: true,
        color: 'rgb(13,148,136)', // Teal
        backgroundClass: 'bg-teal-100', // Background
        textClass: 'text-teal-800', // Text
    },
    {
        id: 4,
        name: 'Aerospace',
        displayName: 'Aerospace',
        selected: true,
        color: 'rgb(93,213,82)', // Green
        backgroundClass: 'bg-green-100', // Background
        textClass: 'text-green-800', // Text
    },
    {
        id: 5,
        name: 'Smart City & Mobility',
        displayName: 'Smart City & Mobility',
        selected: true,
        color: 'rgb(242,167,67)', // Yellow
        backgroundClass: 'bg-amber-100', // Background
        textClass: 'text-amber-800', // Text
    },
    {
        id: 6,
        name: 'Agritech',
        displayName: 'Agritech',
        selected: true,
        color: '#4ABCC8', // Light Blue
        backgroundClass: 'bg-sky-100', // Background (closest to Light Blue)
        textClass: 'text-sky-800', // Text
    },
    {
        id: 7,
        name: 'Quantum Technologies',
        displayName: 'Quantum Technologies',
        selected: true,
        color: 'rgb(153,102,255)', // Purple
        backgroundClass: 'bg-purple-100', // Background
        textClass: 'text-purple-800', // Text
    },
    {
        id: 8,
        name: 'Climate Tech',
        displayName: 'Climate Tech',
        selected: true,
        color: 'rgb(255,206,86)', // Yellow
        backgroundClass: 'bg-yellow-100', // Background
        textClass: 'text-yellow-800', // Text
    },
];
